<template lang="html">
  <div class="company-projects-container">
    <TFlex><h1>{{$t('Company.Projects.Header')}}</h1></TFlex>
    <v-card
      v-for="(project, project_index) in $store.state.Business.projects_overview"
      :key="`companyproject${project.id}`"
      color="color-3"
      class="pa-2 mt-2"
    >
      <TFlex>
        <v-card-title class="cursor-pointer" @click="selected_project_index = project_index">{{project.name}}</v-card-title>
      </TFlex>
      <TFlex width="100%" style="flex-direction:row">
        <v-card
        v-for="issue in project.issues"
        :key="`issue${issue.id}`"
        class="ma-2"
        :color="issue.parent.color"
        :style="`color: ${issue.parent.textcolor}`"
        max-width="344"
        >
          <div v-if="issue.parent_type === 'twork_package'">
            <WorkPackageHead
              :head="{
                token: issue.parent.token,
                name: issue.parent.name,
                icon: issue.parent.icon,
                area: issue.parent.taktarea_name,
                status_done_count: $store.state.Ultra.status_array.findIndex(status => status.name === issue.parent.status),
                status_is_stop: issue.parent.stop_status,
              }"
              :foreground_color="calc_fg_hex(issue.parent.textcolor)"
              :readonly="true"
              />
            <v-card-text>
              {{ issue.text }}
            </v-card-text>
          </div>
        </v-card>
      </TFlex>
      <TFlex
        v-if="selected_project_index === project_index"
        width="100%"
      >
        <!-- FLEX ISSUES START -->


        <!-- FLEX ISSUES END -->
        <!-- FLEX LOGS START -->
        <TFlex width="50%">
          <!-- <h4>TAKT.logs</h4> -->
          <v-timeline>
            <v-timeline-item
              v-for="(log, index) in project.logs.slice(0, 12)"
              :key="`projectlog${log.id}`"
              :class="index%2===0 ? 'text-right':''"
              small
              :color="log.work_package?log.work_package.color:'grey'"
              style="margin-bottom:-20px;"
            >
              {{ log.user + ' ' + log.action + ' ' + log.target + ' ' + log.value }}
            </v-timeline-item>
          </v-timeline>
        </TFlex>
        <!-- FLEX LOGS END -->
        <!-- FLEX OTHER START -->
        <TFlex width="50%" style="flex-direction:column">
          <TFlex width="100%" style="flex-direction:column">
            <h4>TAKT.progress <small>(TAKT.time)</small></h4>
            <v-progress-linear color="purple" height="25" :value="project.current_takt / project.takt_counts * 100"><strong>{{project.current_takt}}/{{project.takt_counts}}</strong></v-progress-linear>
          </TFlex>
          <TFlex width="100%" style="flex-direction:column">
            <h4>TAKT.progress <small>(STATUS.none)</small></h4>
            <v-progress-linear class="cursor-pointer" @click="show_none=!show_none" :color="calcProgressColor(calcNonePercentage(project.current_status_counts.none))" height="25" :value="calcNonePercentage(project.current_status_counts.none)"><strong>{{calcNoneValue(project.current_status_counts.none)}}/{{project.current_status_counts.none.total}}</strong></v-progress-linear>
            <i v-if="show_none" style="font-size:12px;">{{'None: '+project.current_status_counts.none.count_none+' Ready: '+project.current_status_counts.none.count_ready+' Started: '+project.current_status_counts.none.count_started+' Done: '+project.current_status_counts.none.count_done+' Checked: '+project.current_status_counts.none.count_checked+' Closed: '+project.current_status_counts.none.count_closed+' Stop: '+project.current_status_counts.none.count_stop}}</i>
          </TFlex>
          <TFlex width="100%" style="flex-direction:column">
            <h4>TAKT.progress <small>(STATUS.ready)</small></h4>
            <v-progress-linear class="cursor-pointer" @click="show_ready=!show_ready" :color="calcProgressColor(calcReadyPercentage(project.current_status_counts.ready))" height="25" :value="calcReadyPercentage(project.current_status_counts.ready)"><strong>{{calcReadyValue(project.current_status_counts.ready)}}/{{project.current_status_counts.ready.total}}</strong></v-progress-linear>
            <i v-if="show_ready" style="font-size:12px;">{{'None: '+project.current_status_counts.ready.count_none+' Ready: '+project.current_status_counts.ready.count_ready+' Started: '+project.current_status_counts.ready.count_started+' Done: '+project.current_status_counts.ready.count_done+' Checked: '+project.current_status_counts.ready.count_checked+' Closed: '+project.current_status_counts.ready.count_closed+' Stop: '+project.current_status_counts.ready.count_stop}}</i>
          </TFlex>
          <TFlex width="100%" style="flex-direction:column">
            <h4>TAKT.progress <small>(STATUS.started)</small></h4>
            <v-progress-linear class="cursor-pointer" @click="show_started=!show_started" :color="calcProgressColor(calcStartedPercentage(project.current_status_counts.started))" height="25" :value="calcStartedPercentage(project.current_status_counts.started)"><strong>{{calcStartedValue(project.current_status_counts.started)}}/{{project.current_status_counts.started.total}}</strong></v-progress-linear>
            <i v-if="show_started" style="font-size:12px;">{{'None: '+project.current_status_counts.started.count_none+' Ready: '+project.current_status_counts.started.count_ready+' Started: '+project.current_status_counts.started.count_started+' Done: '+project.current_status_counts.started.count_done+' Checked: '+project.current_status_counts.started.count_checked+' Closed: '+project.current_status_counts.started.count_closed+' Stop: '+project.current_status_counts.started.count_stop}}</i>
          </TFlex>
          <TFlex width="100%" style="flex-direction:column">
            <h4>TAKT.progress <small>(STATUS.done)</small></h4>
            <v-progress-linear class="cursor-pointer" @click="show_done=!show_done" :color="calcProgressColor(calcDonePercentage(project.current_status_counts.done))" height="25" :value="calcDonePercentage(project.current_status_counts.done)">
              <strong>{{calcDoneValue(project.current_status_counts.done)}}/{{project.current_status_counts.done.total}}</strong>
            </v-progress-linear>
            <i v-if="show_done" style="font-size:12px;">{{'None: '+project.current_status_counts.done.count_none+' Ready: '+project.current_status_counts.done.count_ready+' Started: '+project.current_status_counts.done.count_started+' Done: '+project.current_status_counts.done.count_done+' Checked: '+project.current_status_counts.done.count_checked+' Closed: '+project.current_status_counts.done.count_closed+' Stop: '+project.current_status_counts.done.count_stop}}</i>
          </TFlex>
          <TFlex width="100%" style="flex-direction:column">
            <h4>TAKT.progress <small>(STATUS.checked)</small></h4>
            <v-progress-linear class="cursor-pointer" @click="show_checked=!show_checked" :color="calcProgressColor(calcCheckedPercentage(project.current_status_counts.checked))" height="25" :value="calcCheckedPercentage(project.current_status_counts.checked)"><strong>{{calcCheckedValue(project.current_status_counts.checked)}}/{{project.current_status_counts.checked.total}}</strong></v-progress-linear>
            <i v-if="show_checked" style="font-size:12px;">{{'None: '+project.current_status_counts.checked.count_none+' Ready: '+project.current_status_counts.checked.count_ready+' Started: '+project.current_status_counts.checked.count_started+' Done: '+project.current_status_counts.checked.count_done+' Checked: '+project.current_status_counts.checked.count_checked+' Closed: '+project.current_status_counts.checked.count_closed+' Stop: '+project.current_status_counts.checked.count_stop}}</i>
          </TFlex>
          <TFlex width="100%" style="flex-direction:row;margin:0px25px;width:50%;margin-left:25%;margin-top:10px;" justify_content="space-between">
            <b>{{project.status_counts.total}}</b>
            <StatusCircle
              v-for="(status_counts_key, index) in ['count_none', 'count_ready', 'count_started', 'count_done', 'count_checked', 'count_closed', 'count_stop']"
              :key="status_counts_key"
              :filled_count="index"
              :is_stop="index === 6 ? true : false"
              :size="55"
              color="#000"
              stop_color="#F44336"
              :count="5"
              :stroke_width="0.4"
              :inner_radius_factor=".75"
              :space="3"
              :readonly="true"
            >
              <template #content>
                {{ project.status_counts[status_counts_key] }}
              </template>
            </StatusCircle>
          </TFlex>
          <TFlex width="100%" style="flex-direction:row;flex-wrap:wrap;">
            <v-card
              v-for="status_counts_type_key in Object.keys(project.status_counts_types)"
              :key="status_counts_type_key"
              :color="status_counts_type_key.split(',')[0]"
              width="50%"
            >
              <WorkPackageHead
                :head="{
                  token: status_counts_type_key.split(',')[1],
                  name: '',
                  icon: status_counts_type_key.split(',')[2],
                  area: '',
                  status_done_count: $store.state.Ultra.status_array.findIndex(status => status.name === 'ready'),
                  status_is_stop: false,
                }"
                foreground_color="#000"
                :readonly="true"
                :hide_status="true"
              />
              <TFlex width="100%" style="flex-direction:row;margin:0px25px;width:80%;margin-left:10%;margin-bottom:10px;" justify_content="space-between">
                <StatusCircle
                  v-for="(status_counts_key_2, index) in ['count_none', 'count_ready', 'count_started', 'count_done', 'count_checked', 'count_closed', 'count_stop']"
                  :key="status_counts_key_2+'2'"
                  :filled_count="index"
                  :is_stop="index === 6 ? true : false"
                  :size="45"
                  color="#000"
                  stop_color="#F44336"
                  :count="5"
                  :stroke_width="0.3"
                  :inner_radius_factor=".75"
                  :space="3"
                  :readonly="true"
                >
                  <template #content>
                    <span style="color:black">{{ project.status_counts_types[status_counts_type_key][status_counts_key_2] }}</span>
                  </template>
                </StatusCircle>
              </TFlex>
            </v-card>
          </TFlex>
        </TFlex>
        <!-- FLEX OTHER END -->
      </TFlex>
    </v-card>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import TFlex from '@/components/Taktify/TFlex.component.vue';
import WorkPackageHead from '@/modules/WorkPackageWIP/WorkPackageHead.module.vue';
import StatusCircle from '@/components/WorkPackageWIP/StatusCircle.component.vue';
import colors from 'vuetify/lib/util/colors';
export default {
  name: 'CompanyManage',
  components: {
    TFlex, WorkPackageHead, StatusCircle
  },
  data: function () {
    return {
      selected_project_index: 0,
      show_none: false,
      show_ready: false,
      show_started: false,
      show_done: false,
      show_checked: false,
    }
  },
  created(){
    this.requestBusinessProjectOverview({business_id: this.getBusiness.id});
  },
  computed: {
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('Business', [
      'getBusiness',
      'hasBusinessPermission'
    ]),
  },
  methods: {
    ...mapActions('Business', [
      'requestBusinessProjectOverview'
    ]),
    calcProgressColor(percent){
      if (percent == 100) {
        return 'green';
      } else if (percent > 80) {
        return 'orange';
      } else {
        return 'red';
      }
    },
    calc_fg_hex(color) {
      let textcolor = color;
      if (textcolor.includes('black')) {
        return '#000'
      } else if (textcolor.includes('white')) {
        return '#FFF'
      } else {
        return colors[textcolor];
      }
    },
    calcNonePercentage(payload) {
      return ( this.calcNoneValue(payload) / payload.total) * 100;
    },
    calcReadyPercentage(payload) {
      return ( this.calcReadyValue(payload) / payload.total) * 100;
    },
    calcStartedPercentage(payload) {
      return ( this.calcStartedValue(payload) / payload.total) * 100;
    },
    calcDonePercentage(payload) {
      return ( this.calcDoneValue(payload) / payload.total) * 100;
    },
    calcCheckedPercentage(payload) {
      return ( this.calcCheckedValue(payload) / payload.total) * 100;
    },
    calcNoneValue(payload) {
      return payload.count_none;
      // return payload.count_none + payload.count_ready + payload.count_started + payload.count_done + payload.count_checked + payload.count_closed;
    },
    calcReadyValue(payload) {
      return payload.count_ready;
      // return payload.count_ready + payload.count_started + payload.count_done + payload.count_checked + payload.count_closed;
    },
    calcStartedValue(payload) {
      return payload.count_started + payload.count_done + payload.count_checked + payload.count_closed;
    },
    calcDoneValue(payload) {
      return payload.count_done + payload.count_checked + payload.count_closed;
    },
    calcCheckedValue(payload) {
      return payload.count_checked + payload.count_closed;
    },
  }
}
</script>

<style lang="scss" scoped>
.company-projects-container {
  width: 90%;
  margin-left: 5%;
}
</style>
